import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  iconColumn: {
    height: pxToRem(20),
    width: pxToRem(20),
    textAlign: 'center',
    fontSize: pxToRem(20),
  },
  iconColumnHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(20),
        width: pxToRem(20),
        textAlign: 'center',
        fontSize: '1rem',
        position: 'absolute',
        top: '50%',
        right: '60%',
        transform: 'translateY(-50%)',
      },
    },
  },
  iconRow: {
    display: 'flex',
    justifyContent: 'space-around',
    flexDirection: 'row',
    width: '100%',
  },
  iconColumnFlex: {
    display: 'flex',
    textAlign: 'right',
    minWidth: pxToRem(10),
    flexDirection: 'column',
    flexBasis: '100%',
    flex: 1,
  },
  secondaryIconColumnFlex: {
    display: 'flex',
    textAlign: 'left',
    minWidth: pxToRem(10),
    flexDirection: 'column',
    flexBasis: '100%',
    flex: 1,
    marginLeft: pxToRem(8),
    marginRight: pxToRem(10),
  },
  actionRequiredIcon: {
    fontSize: pxToRem(20),
  },
  secondaryIcon: {
    fontSize: pxToRem(14),
  },
  headerIcon: {
    maxHeight: pxToRem(20),
    maxWidth: pxToRem(20),
    fontSize: '1rem',
    verticalAlign: 'middle',
  },
  actionButtons: {
    textAlign: 'right',
  },
  viewButton: {
    marginLeft: pxToRem(40),
    fontSize: pxToRem(14),
  },
  bold: {
    fontWeight: 600,
  },
  alignLeft: {
    textAlign: 'left',
    paddingLeft: `${pxToRem(0)} !important`,
  },
  alignRight: {
    textAlign: 'right',
    paddingLeft: `${pxToRem(0)} !important`,
  },
  alignCenter: {
    textAlign: 'center',
    paddingLeft: `${pxToRem(0)} !important`,
  },
  alignBalanceHeader: {
    paddingLeft: `${pxToRem(60)} !important`,
  },
  alignDateCreatedHeader: {
    paddingLeft: `${pxToRem(190)} !important`,
  },
  negativeAmount: {
    color: theme.palette.accentError,
  },
});
